import { render, staticRenderFns } from "./JpReceSelectDialog.vue?vue&type=template&id=0bb19910&scoped=true"
import script from "./JpReceSelectDialog.vue?vue&type=script&lang=js"
export * from "./JpReceSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb19910",
  null
  
)

export default component.exports